export const tryDataLayerPush = (data) => {
    try {
      window.dataLayer.push(data);
    } catch (error) {
      console.error("GTM didn't load");
    }
  };
  